import script from "./ingredient-meta-list-edit.vue?vue&type=script&setup=true&lang=js"
export * from "./ingredient-meta-list-edit.vue?vue&type=script&setup=true&lang=js"

import "./ingredient-meta-list-edit.vue?vue&type=style&index=0&id=d0dbeaa0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0dbeaa0"]])

export default __exports__